import { PropertyInfoDetailed } from "react-migration/domains/ownership/components/PropertyInfoDetailed/PropertyInfoDetailed";
import { useTranslation } from "react-migration/lib";

interface PropertyInformationProps {
  propertyId: string;
  parcelId?: string;
}

export const PropertyInfoTitle = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`atlas-font-semibold atlas-text-xl atlas-text-content-primary atlas-ml-3 atlas-mb-2 ${className}`}
    >
      {t("sites.card.ownership.property_information")}
    </div>
  );
};

export const PropertyInformation = ({ propertyId, parcelId }: PropertyInformationProps) => {
  return !propertyId ? null : (
    <div
      className={propertyId ? "-atlas-ml-3" : "atlas-ml-0"}
      data-testid="ownership-overview-property-info"
    >
      {propertyId && (
        <PropertyInfoDetailed
          propertyId={propertyId}
          parcelId={parcelId}
          TitleElement={<PropertyInfoTitle />}
        />
      )}
    </div>
  );
};
